import { Button as MuiButton, Tooltip as MuiTooltip, withStyles } from '@material-ui/core'
import React, { FC, useState } from 'react'
import styled from 'styled-components'

import InformationIconSvg from '../../../../img/rewards/information-circle.inline.svg'

export interface RewardsInformationTooltipProps {
  className?: string
  placement?: 'top' | 'right' | 'bottom' | 'left'
  forceOpen?: boolean
}

const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#ffffff',
    maxWidth: 498,
    borderRadius: '4px',
    border: 'none',
    boxShadow: '0 0 20px -6px #29282875',
    padding: '24px',
  },
}))(MuiTooltip)

const Content = styled.div`
  display: flex;
  align-items: center;
`

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 24px;
`

const Icon = styled(InformationIconSvg)`
  width: 24px;
  height: 24px;
`

const Text = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 23px;
`

const Button = styled(MuiButton)`
  padding: 5px;
  height: 30px;
  width: 30px;
  min-width: 0;
  color: inherit;
`

const InformationIcon = styled(InformationIconSvg)`
  stroke: currentColor;

  path {
    stroke: currentColor;
  }
`

export const RewardsInformationTooltip: FC<RewardsInformationTooltipProps> = ({
  children,
  className,
  placement,
  forceOpen,
}) => {
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)
  const handleOpen = () => setOpen(true)
  const handleIconClick = () => setOpen((prevOpen) => !prevOpen)
  return (
    <Tooltip
      className={className}
      title={
        <Content>
          <IconWrapper>
            <Icon />
          </IconWrapper>
          <Text>{children}</Text>
        </Content>
      }
      placement={placement ?? 'right'}
      interactive
      open={forceOpen || open}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      <Button onClick={handleIconClick}>
        <InformationIcon />
      </Button>
    </Tooltip>
  )
}
